import React from 'react';
import PhotoUpload from 'components/PhotoUpload';
import { CAMPO_TEXTO } from './comun';

export default function PasoObservaciones({ fotoBlobs, onFotos, comentarios, onComentarios }) {
  return (
    <div>
      <h2 tabIndex={-1} className="text-2xl font-bold leading-tight text-foreground focus:outline-none">
        Observaciones
      </h2>
      <p className="mt-2 text-base leading-snug text-muted-foreground">
        Opcional. Agregue fotos generales o algo importante que deba saber administración.
      </p>
      <div className="mt-5">
        <PhotoUpload value={fotoBlobs} onChange={onFotos} />
      </div>
      <label htmlFor="comentarios" className="mt-5 block text-base font-semibold text-foreground">
        Comentarios importantes
      </label>
      <textarea
        id="comentarios"
        rows={4}
        value={comentarios}
        onChange={(e) => onComentarios(e.target.value)}
        className={`mt-2 ${CAMPO_TEXTO}`}
      />
    </div>
  );
}
